import { Icon } from "@/components";
import clsx from "clsx";

interface Props {
  label?: string;
  isAsterisk?: boolean;
  isWarning?: boolean;
  errorMessage?: string;
  wrapClassName?: string;
  id?: string;
  isDisplayOnClear?: boolean;
  iconType?: "stroke" | "fill";
  iconRight?: React.ElementType;
  iconLeft?: React.ElementType;
  children: React.ReactNode;
  onClear?: () => void;
  iconClassName?: string;
}

export const WrapInput = ({
  label,
  isAsterisk,
  isWarning,
  errorMessage,
  wrapClassName,
  iconType = "fill",
  iconRight: IconRight = undefined,
  iconLeft: IconLeft = undefined,
  id,
  children,
  isDisplayOnClear,
  onClear,
  iconClassName,
}: Props) => {
  return (
    <div className={clsx(wrapClassName)}>
      {Boolean(label) && (
        <label
          htmlFor={id}
          className="mb-1 block text-base font-semibold text-neutral-90"
        >
          {label}
          {isAsterisk && <span className="text-red ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {IconLeft && (
          <div
            className={clsx(
              "absolute inset-y-0 left-0 pl-3 flex items-center",
              // Add pointer-events-none for Icon components
              Object.values(Icon).some((IconComp) => IconComp === IconLeft) &&
                "pointer-events-none"
            )}
          >
            <IconLeft
              className={clsx(
                iconType === "fill" ? "fill-neutral-40" : "stroke-neutral-40",
                iconClassName
              )}
              size="16"
            />
          </div>
        )}
        {children}
        {isDisplayOnClear && (
          <button
            type="button"
            tabIndex={-1}
            onClick={onClear}
            className={clsx(
              "absolute inset-y-0 flex items-center group z-50",
              IconRight ? "right-10" : "right-3"
            )}
          >
            <Icon.Close
              size="12"
              className="stroke-neutral-40 group-hover:stroke-neutral-80"
            />
          </button>
        )}
        {IconRight && (
          <div
            className={clsx(
              "absolute inset-y-0 right-0 pr-3 flex items-center",
              // Add pointer-events-none for Icon components
              Object.values(Icon).some((IconComp) => IconComp === IconRight) &&
                "pointer-events-none"
            )}
          >
            <IconRight
              className={clsx(
                iconType === "fill" ? "fill-neutral-40" : "stroke-neutral-40",
                iconClassName
              )}
              size="16"
            />
          </div>
        )}
      </div>
      {Boolean(errorMessage) && (
        <p
          className={clsx(
            "mt-[0.375rem] text-sm text-red",
            isWarning ? "text-yellow-dark" : "text-red"
          )}
          id="email-error"
        >
          {errorMessage}
        </p>
      )}
    </div>
  );
};
